import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogueSignupComponent } from '@kp/dialogue/components/dialogue-signup/dialogue-signup.component';
import { DialogueRoutingModule } from '@kp/dialogue/dialogue-routing.module';
import { DialogueStatusComponent } from '@kp/dialogue/dialogue-status/dialogue-status.component';
import { ImageIconComponent } from '@kp/question-set/answer/word-list/image-icon/image-icon.component';
import { QuestionComponent } from '@kp/question-set/question/question.component';
import { SharedModule } from '@kp/shared/shared.module';

@NgModule({
  declarations: [DialogueRoutingModule.components],
  imports: [CommonModule, DialogueRoutingModule, FormsModule, SharedModule],
  exports: [DialogueSignupComponent, DialogueStatusComponent, QuestionComponent, ImageIconComponent],
})
export class DialogueModule {}
